import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useNetworkStatusContext } from '../../contexts/NetworkStatusContext';

export const NetworkStatus: React.FC = () => {
  const { isOnline, hasExhaustedRetries } = useNetworkStatusContext();

  return (
    <>
      <Snackbar 
        open={!isOnline} 
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          severity={hasExhaustedRetries ? "error" : "warning"} 
          sx={{ width: '100%' }}
        >
          {hasExhaustedRetries
            ? 'Connection lost. Please check your internet connection.'
            : 'Attempting to reconnect...'}
        </Alert>
      </Snackbar>
    </>
  );
}; 